import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuperAdminManagementComponent } from './super-admin-management.component';
import { ApiClient } from '../core/api-client.service';
import { BrowserModule } from '@angular/platform-browser';
import { AddEditSuperAdminModalComponent } from './Modals/add-edit-super-admin-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    SuperAdminManagementComponent,
    AddEditSuperAdminModalComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
    , FormsModule
    , ReactiveFormsModule 
    , NgbPaginationModule
  ],
  providers: [ApiClient],
})
export class SuperAdminModule { }
